import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-switch-profile-modal',
  styleUrls: ['./switch-profile-modal.component.scss'],
  templateUrl: './switch-profile-modal.component.html',
})
export class SwitchProfileModalComponent {
  @Input() public canSwitchProfile: boolean;

  @Output() public close: EventEmitter<any> = new EventEmitter<any>();
  @Output() public switchProfile: EventEmitter<any> = new EventEmitter<any>();

  public emitClose(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.close.emit();
  }

  public emitSwitchProfile(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.switchProfile.emit();
  }
}
